/* eslint-disable */
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class VNumberValidators {
    static isEmptyInputValue(value: any): boolean {
        return value == null || value.length === 0;
    }

    /**
     * Must match validator
     *
     * @param rightControlPath A dot-delimited string values that define the path to the control.
     * @param leftControlPath A dot-delimited string values that define the path to the matching control.
     */
    static greaterThan(rightControlPath: string, leftControlPath: string): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            // Get the control and matching control
            const leftControl = formGroup.get(leftControlPath);
            const rightControl = formGroup.get(rightControlPath);

            // Return if control or matching control doesn't exist
            if (!leftControl || !rightControl) {
                return null;
            }

            // Delete the mustMatch error to reset the error on the matching control
            if (rightControl.hasError("greaterThan")) {
                delete rightControl.errors.mustMatch;
                rightControl.updateValueAndValidity();
            }

            // Don't validate empty values on the matching control
            // Don't validate if values are matching
            if (this.isEmptyInputValue(rightControl.value) || this.isEmptyInputValue(leftControl.value)) {
                return null;
            }

            const leftValue = leftControl.value as number;
            const rightValue = rightControl.value as number;

            if (rightValue > leftValue) {
                return null;
            }

            // Prepare the validation errors
            const errors = { greaterThan: true };

            // Set the validation error on the matching control
            rightControl.setErrors(errors);

            // Return the errors
            return errors;
        };
    }
}
